export default __webpack_public_path__ + "static/media/kia.5bef1f0c.svg";